import "../sass/app.scss";

import ThreeSlideCarousel from "./modules/ThreeSlideCarousel";
import HomeCarousel from "./modules/HomeCarousel";
import StickyMenu from "./modules/StickyMenu";
import Animations from "./modules/Animations";
import CollapseMobileMenu from "./modules/CollapseMobileMenu";
import AutoMarginTop from "./modules/AutoMarginTop";
import GravityFormScroll from "./modules/GravityFormsScroll";


const threeSlideCarousel = new ThreeSlideCarousel();
const homeCarousel = new HomeCarousel();
const stickyMenu = new StickyMenu();
const animations = new Animations();
const collapseMobileMenu = new CollapseMobileMenu();
const autoMarginTop = new AutoMarginTop();
const gravityFormScroll = new GravityFormsScroll();
